var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 29.25,
    viewBox: "0 0 22.5 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.25,3.375H9.563A2.812,2.812,0,0,0,6.75,6.188V29.812a2.812,2.812,0,0,0,2.813,2.813H26.437a2.812,2.812,0,0,0,2.812-2.813V12.375ZM19.125,13.5V5.625L27,13.5Z",
    transform: "translate(-6.75 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowupIcon);
export default __webpack_public_path__ + "static/media/followup-icon.aa5c5d0270935e99f1aee817bf602e37.svg";
export { ForwardRef as ReactComponent };